import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';
import User from '_class/User';
import moment from 'moment';
import { getSMSList, createSMS, getRemainingSMS, getSMSEducationSections, getSMSMentorSections } from 'actions/sms';
import { setPageTitle, setPageActions } from 'actions/header';
import { getSchoolServices } from 'actions/schools';
import Modal from 'containers/Modals/Modal';
import SMSForm from 'containers/Forms/SMS';
import DatePickerFromTo from 'containers/Forms/Partials/DatePickerFromTo';
import { Spinner } from 'UI';
import { Card, Grid, Radio, Icon, translate } from '@haldor/ui';

var SMSOverview = /*#__PURE__*/function (_Component) {
  _inherits(SMSOverview, _Component);

  var _super = _createSuper(SMSOverview);

  function SMSOverview(props) {
    var _this;

    _classCallCheck(this, SMSOverview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.setPageTitle('Sms');

      var user = new User(_this.props.user);
      var actions = [];
      actions.push({
        type: 'button',
        value: _this.props.translate('Write sms'),
        onClick: _this.onFormToggle,
        icon: 'plus'
      });

      _this.props.setPageActions(actions);

      _this.props.getRemainingSMS();

      var school = user.getActiveSchool();

      _this.props.getSchoolServices(school.id).then(function () {
        var foundSMS = _this.props.services.find(function (service) {
          return service.serviceId == 'HALDOR_SMS' && moment(service.serviceEnd).isSameOrAfter(moment(), 'day');
        });

        if (foundSMS != null) {
          _this.setState({
            loadingServices: false
          });
        } else {
          _this.props.history.replace('/');
        }
      });

      _this.props.getSMSEducationSections();

      _this.props.getSMSMentorSections();

      _this.fetchData();
    });

    _defineProperty(_assertThisInitialized(_this), "fetchData", function () {
      var _this$state = _this.state,
          statusFilter = _this$state.statusFilter,
          groupFilter = _this$state.groupFilter,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var group = null;

      if (groupFilter != 0) {
        group = groupFilter;
      }

      var utcStart = moment(moment(startDate).startOf('day'), 'YYYY-MM-DD  HH:mm:ss').utc().format();
      var utcEnd = moment(moment(endDate).endOf('day'), 'YYYY-MM-DD HH:mm:ss').utc().format();

      _this.props.getSMSList(group, statusFilter, utcStart, utcEnd);
    });

    _defineProperty(_assertThisInitialized(_this), "filterOnGroup", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var groupId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                groupId = parseInt(event.target.value, 10);

                if (!(groupId < 1)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return _this.setState({
                  groupFilter: 0
                });

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return _this.setState({
                  groupFilter: groupId
                });

              case 8:
                _this.fetchData();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "clearGroupFilter", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event.preventDefault();
                _context2.next = 3;
                return _this.setState({
                  groupFilter: 0
                });

              case 3:
                _this.fetchData();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onFilterDateChange", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dates) {
        var _this$state2, startDate, endDate;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$state2 = _this.state, startDate = _this$state2.startDate, endDate = _this$state2.endDate;

                if (!(dates.start.format('YYYY-MM-DD') == startDate && dates.end.format('YYYY-MM-DD') == endDate)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", false);

              case 3:
                _context3.next = 5;
                return _this.setState({
                  startDate: dates.start.format('YYYY-MM-DD'),
                  endDate: dates.end.format('YYYY-MM-DD')
                });

              case 5:
                _this.fetchData();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onStatusFilterChange", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(filter) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(filter == _this.state.statusFilter)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", false);

              case 2:
                _context4.next = 4;
                return _this.setState({
                  statusFilter: filter
                });

              case 4:
                _this.fetchData();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onFormToggle", function () {
      _this.setState({
        form: !_this.state.form
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      return new Promise(function (resolve, reject) {
        _this.props.createSMS(values).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  resolve(1);

                  if (!(values.status != _this.state.statusFilter)) {
                    _context5.next = 7;
                    break;
                  }

                  _context5.next = 4;
                  return _this.setState({
                    form: false,
                    statusFilter: values.status
                  });

                case 4:
                  _this.fetchData();

                  _context5.next = 8;
                  break;

                case 7:
                  _this.setState({
                    form: false
                  });

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })))["catch"](function () {
          reject(_this.props.translate('Something went wrong, try again'));
        });
      });
    });

    _this.state = {
      loadingServices: true,
      form: false,
      groupFilter: 0,
      statusFilter: 'SMS_PUBLISHED',
      startDate: moment().subtract('3', 'months').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    };
    return _this;
  }

  _createClass(SMSOverview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.user);

      if (!user.isAdministrator() && !user.isSchoolLeader() && !user.isSMSAdmin()) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }

      var data = null;

      if (this.props.list != null) {
        data = _toConsumableArray(this.props.list).sort(function (a, b) {
          return b.id - a.id;
        });
      }

      if (this.state.loadingServices) {
        return /*#__PURE__*/React.createElement("div", {
          className: "preschooldocuments"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var sections = [];

      if (this.props.educationSections != null) {
        sections = sections.concat(this.props.educationSections);
      }

      if (this.props.mentorSections != null) {
        sections = sections.concat(this.props.mentorSections);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "preschooldocuments"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.form,
        onClose: this.onFormToggle,
        title: "SMS"
      }, /*#__PURE__*/React.createElement(SMSForm, {
        onSubmit: this.onSubmit,
        onCancel: this.onFormToggle
      })), /*#__PURE__*/React.createElement("div", {
        className: "section-header form",
        style: {
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "option-container filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row select"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Group')), /*#__PURE__*/React.createElement("select", {
        value: this.state.groupFilter,
        onChange: this.filterOnGroup
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, this.props.translate('select-an-alternative')), sections.map(function (group) {
        return /*#__PURE__*/React.createElement("option", {
          value: group.id,
          key: group.id
        }, group.title);
      }))), this.state.groupFilter > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "clear-filter-container",
        onClick: this.clearGroupFilter
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Close"
      }), " ", this.props.translate('clear-filter')) : null), /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
        values: {
          start: this.state.startDate,
          end: this.state.endDate
        },
        onChange: this.onFilterDateChange
      }))), /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Status')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Radio, {
        input: {
          onChange: this.onStatusFilterChange,
          value: this.state.statusFilter
        },
        optionValue: "SMS_PUBLISHED",
        label: this.props.translate('Published')
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Radio, {
        input: {
          onChange: this.onStatusFilterChange,
          value: this.state.statusFilter
        },
        optionValue: "SMS_DRAFT",
        label: this.props.translate('Draft')
      }))))), /*#__PURE__*/React.createElement(Grid, null, data != null ? data.map(function (sms) {
        return /*#__PURE__*/React.createElement(Card, {
          element: Link,
          to: "/sms/".concat(sms.id),
          key: sms.id,
          className: "fc ais"
        }, /*#__PURE__*/React.createElement("div", {
          className: "df jcb aic x size-14",
          style: {
            marginBottom: '1rem'
          }
        }, /*#__PURE__*/React.createElement("div", null, sms.createdUser.firstName, " ", sms.createdUser.lastName), /*#__PURE__*/React.createElement("div", {
          className: "size-12"
        }, sms.status == 'SMS_DRAFT' ? /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            marginRight: '.45rem'
          }
        }, _this2.props.translate('Draft')) : null, new DateTime(sms.created).getTimeStampHours())), sms.title != null ? /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '0.45rem',
            fontSize: '1rem',
            fontWeight: 500
          }
        }, sms.title) : null, /*#__PURE__*/React.createElement("div", {
          className: "size-14"
        }, sms.message));
      }) : null));
    }
  }]);

  return SMSOverview;
}(Component);

function mapStateToProps(state) {
  return {
    user: state.user.currentUser,
    translate: translate(state.Languages.translations),
    list: state.SMS.list,
    services: state.School.schoolServices,
    educationSections: state.SMS.educationSections,
    mentorSections: state.SMS.mentorSections
  };
}

export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getSMSList: getSMSList,
  createSMS: createSMS,
  getRemainingSMS: getRemainingSMS,
  getSchoolServices: getSchoolServices,
  getSMSMentorSections: getSMSMentorSections,
  getSMSEducationSections: getSMSEducationSections
})(SMSOverview);